import { render, staticRenderFns } from "./properties.vue?vue&type=template&id=cbac56f2&scoped=true&"
import script from "./properties.vue?vue&type=script&lang=js&"
export * from "./properties.vue?vue&type=script&lang=js&"
import style0 from "./properties.vue?vue&type=style&index=0&id=cbac56f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbac56f2",
  null
  
)

export default component.exports